import { styled, Dialog, dialogClasses } from '@mui/material';

export const DialogEditScheduleRouteContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 600,
    width: '100%',
    minHeight: 680,
  },
});

export const DialogEditScheduleRouteLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});
